import {Component,OnInit,ViewChild} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';

import {ModalDirective} from 'ngx-bootstrap';
import {Principal} from 'src/app/core';
import {ICargoGroupMySuffix} from 'src/app/shared/model/cargo-group-my-suffix.model';
import {ICountryMySuffix} from 'src/app/shared/model/country-my-suffix.model';
import {ISanctionedGroupMySuffix} from 'src/app/shared/model/sanctioned-group-my-suffix.model';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {CommonUtils} from 'src/app/shared/util/common-utils';
import {RoleUtil} from 'src/app/shared/util/role-util';
declare let $: any;
@Component({
    selector: 'jhi-sanctioned-group-my-suffix-detail',
    templateUrl: './sanctioned-group-my-suffix-detail.component.html'
})
export class SanctionedGroupMySuffixDetailComponent implements OnInit {
    @ViewChild('viewMoreModal') viewMoreModal: ModalDirective;
    @ViewChild('addCargoModal') addCargoModal: ModalDirective;
    
    sanctionedGroup: ISanctionedGroupMySuffix;
    isShowPastHistory: boolean;
    isShowFutureHistory: boolean;
    countries: ICountryMySuffix[];
    cargogroups: ICargoGroupMySuffix[];
    isDropDownDisabled: boolean = false;
    isSaving: boolean;
    fromEffeciveDate: any;
    dateModel = {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getDate()
    }
    selectedCountry: ICountryMySuffix[] = [];
    selectedCargoList: ICargoGroupMySuffix[] = [];

    public readonly RoleUtil=RoleUtil;

    CountriesDropdownSettings = {
        singleSelection: false,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true,
        idField: 'id',
        textField: 'name',
        defaultOpen: false
    };

    cargogroupsDropdownSettings = {
        singleSelection: false,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true,
        idField: 'id',
        textField: 'name',
        itemsShowLimit: 5,
        defaultOpen: false
    };
    constructor(private principal: Principal, 
        private activatedRoute: ActivatedRoute,
        // private sanctionedGroupService: SanctionedGroupMySuffixService,
         private languageChangeService:LanguageChangeService,
        private router: Router,
        // private countryService: CountryMySuffixService,
        // private jhiAlertService: JhiAlertService,
        // private cargoGroupService: CargoGroupMySuffixService,
         ) {
                    this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
                window.history.back()
            }
    });
          }

    ngOnInit() {
        this.isSaving = false;
        this.fromEffeciveDate = { date: this.dateModel };
        this.isShowPastHistory = this.principal.isShowPastHistory;
        this.isShowFutureHistory = this.principal.isShowFutureHistory;
        this.activatedRoute.data.subscribe(({ sanctionedGroup }) => {
            this.sanctionedGroup = sanctionedGroup;
        });
        // this.getAllCountry();
        // this.getAllCargoes();
    }

    previousState() {
        window.history.back();
    }

    // history
    historyData = [];
    historyTitle: string;
    historyType: string;
    historyId: number;
    
    parentHistoryToggle = false;
    parentFutureHistoryToggle = false;
    receiveToggleEvent($event) {
        this.parentHistoryToggle = $event;
        this.parentFutureHistoryToggle = $event;
    }

	viewFutureHistory(Obj) { //Future Records
        this.parentFutureHistoryToggle = true;
        this.historyTitle = 'Sanctioned Groups (' + Obj.name + ') Future Records';
        this.historyType = "SANCTION_GROUPS_AUDIT";
        this.historyId = Obj.id;

	}

    viewHistory(Obj) {
        this.parentHistoryToggle = true;
        this.historyTitle = 'Sanctioned Groups (' + Obj.name + ') History';
        this.historyType = "SANCTION_GROUPS_AUDIT";
        this.historyId = Obj.id;
    }
    hideFutureHistorySidebar() {
        if (document.getElementById("future-history-window")) {
            this.parentHistoryToggle = false;
            this.parentFutureHistoryToggle = false;
        }
    }

    dataText="";
    viewMoreData: any[]=[];
    showViewMoreModal(data,dataText) {
        
        this.viewMoreData = data;
        this.viewMoreModal.show();
        this.dataText=dataText;

    }

    hideViewMoreModal() {
        this.viewMoreModal.hide();
        this.viewMoreData=[];
        this.dataText=""
    }

    onNavigate(countryList){
        if (CommonUtils.isNotNil(countryList)){
            this.router.navigate(['/data-management/sanctioned-group/' + this.sanctionedGroup.id + '/edit'], { queryParams: { ...countryList, addWhiteListCargo: true } });
        }
    }

    // openAddCargoModal(countryList: any) {
    //     console.log(countryList);
    //     this.selectedCountry = [countryList];

    //     if (this.sanctionedGroup.cargoCountryList.length > 0) {
    //         let cargoCountry = this.sanctionedGroup.cargoCountryList.filter((cc: CargoCountryList) => {
    //             return cc.country.id == countryList.id
    //         })
    //         if (cargoCountry == undefined || cargoCountry.length == 0 || cargoCountry.length > 1) {
    //             this.selectedCargoList=[];
    //         } else {
    //             this.selectedCargoList = cargoCountry[0].cargoLists;
    //         }
    //     }
    //     this.addCargoModal.show();
    //     this.isDropDownDisabled = true;
    // }

    // hideAddCargoModal() {
    //     this.addCargoModal.hide();
    // }
    // private onError(errorMessage: string) {
    //     this.jhiAlertService.error(errorMessage, null, null);
    // }
    // getAllCountry() {
    //     this.countryService
    //         .query({
    //             page: 0,
    //             size: 300
    //             // sort: null
    //         })
    //         .subscribe(
    //             (res: HttpResponse<ICountryMySuffix[]>) => {
    //                 this.countries = res.body;              
    //             },
    //             (res: HttpErrorResponse) => this.onError(res.message)
    //         );
    // }

    // getAllCargoes() {
    //     this.cargoGroupService.queryAll().subscribe(
    //         (res: HttpResponse<ICargoGroupMySuffix[]>) => {
    //             this.cargogroups = res.body;
    //         },
    //         (res: HttpErrorResponse) => this.onError(res.message)
    //     );

    // }
    // onSelectSanctionList(event) {
    //     $(document).find('.sanctionListClass .dropdown-list').addClass('showDropdown');
    // }
    
    // onSelectCargos(event) {
    //     console.log(event)
    // }
    // onDeSelectCargos(event) {
    //     this.sanctionedGroup.cargoLists.splice(event , 1);
    // }
    // onSelectAllCargos(event) {
    //     this.cargogroups.forEach(data => {
    //             this.sanctionedGroup.cargoLists.push(data);
    //     })
    // }
    // onDeSelectAllCargos(event) {
    //     this.sanctionedGroup.cargoLists = [];
    // }

    // onSubmit() {
    //     if (this.selectedCargoList == undefined || this.selectedCargoList == null || this.selectedCountry==undefined || this.selectedCountry==null) {
    //         this.sanctionedGroup.cargoCountryList = [];
    //     }

    //     // always send the record which is going to be updated
    //     this.sanctionedGroup.cargoCountryList=[ new CargoCountryList(null,this.selectedCountry[ 0 ],this.selectedCargoList)];

    //     this.isSaving = true;
    //     let incDate = this.principal.dateFormateClientToServer(this.fromEffeciveDate.date);
    //     this.sanctionedGroup.fromEffectiveDate = incDate;
    //     if (this.sanctionedGroup.id !== undefined) {
    //         this.subscribeToSaveResponse(this.sanctionedGroupService.cargoUpdate(this.sanctionedGroup));
    //     }
    // }

    // private subscribeToSaveResponse(result: Observable<HttpResponse<ISanctionedGroupMySuffix>>) {
    //     result.subscribe(
    //         (res: HttpResponse<ISanctionedGroupMySuffix>) => this.onSaveSuccess(),
    //         (res: HttpErrorResponse) => this.onSaveError()
    //     );
    // }

    // getViewData() {
    //     this.sanctionedGroupService.view(this.sanctionedGroup.id).subscribe(res => {
    //         this.sanctionedGroup = res.body;   
    //     })
    // }
    // private onSaveSuccess() {
    //     this.isSaving = false;
    //     this.addCargoModal.hide();
    //     this.getViewData();
    // }

    // private onSaveError() {
    //     this.isSaving = false;
    // }
}
